// Carga condicional del vídeo de portada.
//
// Sale de landing.js del sitio headless, separado a su propio archivo porque en
// el tema el resto de landing.js ya no hace falta: la rejilla de cremas la pinta
// Liquid desde la colección. Cargar el módulo entero solo por el vídeo habría
// duplicado el pintado de productos.
//
// El <video> viene SIN src y aquí se decide si ponérselo. Las tres razones para
// no hacerlo:
//
//   1. El usuario ha activado el ahorro de datos. Es una petición explícita suya
//      y se respeta.
//   2. La conexión que reporta el navegador es lenta (2g/3g). El vídeo no
//      llegaría a verse antes de que la persona se haya ido.
//   3. Ha pedido menos movimiento en su sistema. Un vídeo en bucle a pantalla
//      completa es exactamente lo que quiere evitar.
//
// En los tres casos la portada se queda con su fondo hueso y el texto encima,
// que es una primera pantalla perfectamente buena. Nada se rompe.
//
// navigator.connection no existe en Safari ni en Firefox: ahí `conexion` es
// undefined y se asume buena conexión. Es lo correcto: ante la duda, dar el
// contenido completo en vez de recortarlo por si acaso.

const video = document.querySelector('[data-video]');

if (video) {
  const conexion = navigator.connection;
  const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ahorroDatos = conexion?.saveData === true;
  const conexionLenta = ['slow-2g', '2g', '3g'].includes(conexion?.effectiveType);

  if (!menosMovimiento && !ahorroDatos && !conexionLenta && video.dataset.src) {
    // 'canplay' y no 'loadeddata': canplay significa que hay buffer suficiente
    // para arrancar sin cortarse. Con loadeddata el vídeo aparece y se congela
    // en el primer fotograma, que se ve peor que no haberlo puesto.
    video.addEventListener('canplay', () => video.classList.add('listo'), { once: true });

    // Si el archivo falla (404, red caída, formato no soportado) no se hace
    // nada: la portada se queda con su fondo. Un vídeo roto no puede dejar la
    // primera pantalla en negro.
    video.addEventListener('error', () => {
      console.warn('[portada] el vídeo no se ha podido cargar; se deja el fondo liso.');
    }, { once: true });

    video.src = video.dataset.src;

    // play() devuelve una promesa que iOS rechaza si considera que el gesto no
    // procede. Se captura para que no salga un error sin manejar en consola:
    // que el vídeo no arranque solo es aceptable, un error rojo no.
    video.play?.().catch(() => {});
  }

  // Con la pestaña en segundo plano el vídeo sigue decodificando y gastando
  // batería sin que nadie lo mire. Se pausa y se reanuda al volver.
  document.addEventListener('visibilitychange', () => {
    if (!video.src) return;
    if (document.hidden) video.pause();
    else video.play?.().catch(() => {});
  });
}
